import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";
import {validateEmail} from "../../../functions/EmailValidation";

const EditPersonValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";

  const checkPassports = (passports) => {
    let errors = [];

    if ( !passports || passports.length < 1)
      errors.push(`At least one Passport should be included with the person's record`);

    if (passports && Array.isArray(passports)) {
      for (let i = 0; i < passports.length; i++) {
        const passportRecord = passports[i];
        if (!passportRecord.countryCode || !passportRecord.passportNumber || !passportRecord.issueDate || !passportRecord.expiryDate ) {
          errors.push(`Passport information is incomplete`);
        }
      }
    }

    return errors;
  }

  if (!error && !record.title) {
    error = true;
    errorMessage = "'Title' is required";
  }
  if (!error && !record.forename) {
    error = true;
    errorMessage = "'First Name' is required";
  }
  if (!error && !record.surname) {
    error = true;
    errorMessage = "'Last Name' is required";
  }
  if (!error && !record.sex) {
    error = true;
    errorMessage = "Person's 'Sex' is required";
  }
  if (!error && !record.doB) {
    error = true;
    errorMessage = "'Date of Birth' is required";
  }
  if (!error && !record.phone && !record.email) {
    error = true;
    errorMessage = "At least one contact information (Phone or Email) is required";
  }
  if (!error && record.email && !validateEmail(record.email)) {
    error = true;
    errorMessage = `${record.email} is not a valid email address`;
  }


  if (!error) {
    const passportErrors = checkPassports(record.passports);
    if (passportErrors && passportErrors.length > 0) {
      error = true;
      errorMessage = passportErrors[0];
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default EditPersonValidator;
